import { getValidationErrorsByLineItem } from "../../../../utils/utils/get-validation-errors-by-line-item.js";
import { toVisualLineItem } from "../../visual-line-item/mappers/view/visual-line-item/cart-line-item.js";
import { lineItemDataMapper } from "../../../../utils/utils/line-item-data-mapper.js";
import { mapAppliedCartDiscounts } from "../../../../utils/utils/map-applied-cart-discounts.js";
import { createContainsHelper } from "../../../../utils/utils/create-contains-helper.js";
import { LoyaltyCardType } from "../../../../models/cart/models/cart/cart.js";
import { getCustomerDetails } from "../../../../utils/utils/get-customer-details.js";
import { getShippingMethod } from "../../../../utils/utils/get-shipping-method.js";
import { getAddress } from "../../../../utils/utils/get-address.js";
import { getActiveVoucherNames, getActiveVoucherCodes } from "../../../../utils/utils/get-active-voucher-codes.js";
import { getCartPrices } from "../../../../utils/utils/get-cart-prices.js";
const toCartView = (cart, validationErrors, settings, intl, apiUrl) => {
  const lineItemsRaw = cart.lineItems;
  const lineItems = lineItemDataMapper(lineItemsRaw, settings, intl);
  const visualLineItems = lineItemsRaw.map((lineItemRaw) => toVisualLineItem(lineItemRaw, intl, settings, apiUrl)).filter((lineItem) => Boolean(lineItem));
  return {
    id: cart.id,
    numberOfItems: cart.numberOfItems,
    hasDistinctDeliveryEstimations: cart.hasDistinctDeliveryEstimations,
    lineItems,
    visualLineItems,
    hasSubscription: cart.hasSubscription,
    validationErrors: getValidationErrorsByLineItem(validationErrors),
    additionalCartCostLineItems: cart.additionalCartCostLineItems,
    prices: getCartPrices(cart.price, cart.shippingMethod),
    voucherCodes: getActiveVoucherCodes(cart.vouchers),
    voucherNames: getActiveVoucherNames(cart.vouchers),
    isAccountRequired: !!cart.isAccountRequired,
    billingAddress: getAddress(cart.billingAddress),
    shippingAddress: getAddress(cart.shippingAddress),
    shippingMethod: getShippingMethod(cart.shippingMethod),
    customerDetails: getCustomerDetails(cart.customerDetails),
    checkoutState: cart.checkoutState,
    serviceStore: cart.serviceStore ? { globalStoreId: cart.serviceStore.globalStoreId } : void 0,
    loyaltyDetails: {
      cardNumber: cart.loyaltyDetails.cardNumber || null,
      points: cart.loyaltyDetails.points,
      type: cart.loyaltyDetails.cardNumberType ? LoyaltyCardType[cart.loyaltyDetails.cardNumberType] : null
    },
    contains: createContainsHelper(lineItems),
    appliedCartDiscounts: mapAppliedCartDiscounts(cart?.cartAppliedDiscounts, intl.locale),
    hasAlternativeShippingState: cart.hasAlternativeShippingState
  };
};
export {
  toCartView
};
//# sourceMappingURL=to-cart-view.js.map
